import { render, staticRenderFns } from "./VrRefundList.vue?vue&type=template&id=5ffd32b1&scoped=true&"
import script from "./VrRefundList.vue?vue&type=script&lang=js&"
export * from "./VrRefundList.vue?vue&type=script&lang=js&"
import style0 from "./VrRefundList.vue?vue&type=style&index=0&id=5ffd32b1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ffd32b1",
  null
  
)

export default component.exports